<div class="row mb-2">
  <div class="col text-end">
<button *ngIf="(request.status.code === 'PIC' || request.status.code === 'TPA'  || request.status.code === 'VAL' || (request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DPS') || (isDatePresent('DPS') && !request.facility) ))) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-toggle="modal" (click)="getStructureTypes()" data-bs-target="#structureModal">
    Scegli Struttura
</button>
<button *ngIf="(request.status.code === 'PIC' || request.status.code === 'TPA'  || request.status.code === 'VAL' || (request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DPS')))) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code == 'CPD' || request.setting.subSettings[0].code == 'CPDMP')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-toggle="modal" data-bs-target="#ucpdomRequestModal">
    UCPDOM
</button>
  <button *ngIf="request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DCS'))  && request.facility && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#confirmStructureModal" data-bs-toggle="modal">
    Conferma Struttura
  </button>

    <button *ngIf="request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DCS')) && isDatePresent('DPS')  && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code == 'CPD' || request.setting.subSettings[0].code == 'CPDMP')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#ucpdomConfirmModal" data-bs-toggle="modal">
    Conferma Arruolamento
  </button>

  <button *ngIf="request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DCS')) && request.facility && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#facilityRefuseModal" data-bs-toggle="modal"
          >
    Rifiuta Struttura
  </button>

    <button *ngIf="request.status.code === 'CPZ' && (!requestDates || !isDatePresent('DCS')) && isDatePresent('DPS') && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code == 'CPD' || request.setting.subSettings[0].code == 'CPDMP')"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#ucpdomRefuseModal" data-bs-toggle="modal"
          >
    Rifiuta Arruolamento
  </button>
  <button *ngIf="request.status.code === 'SS' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
           [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#confirmStructureModal" data-bs-toggle="modal">
    Conferma Struttura
  </button>
    <button *ngIf="request.status.code === 'SS' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-toggle="modal" (click)="getStructureTypes()" data-bs-target="#structureModal">
    Scegli Struttura
  </button>
  <button *ngIf="request.status.code === 'CS' && (requestDates && isDatePresent('DCS')) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          (click)="confermaPaziente()">
    Paziente Accetta
  </button>
  <button *ngIf="request.status.code === 'CPZ' && (requestDates && isDatePresent('DCS')) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          (click)="confermaPaziente()">
    Paziente Accetta
  </button>
  <button *ngIf="request.status.code === 'CS' && (requestDates && isDatePresent('DCS')) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#patientRefuseModal" data-bs-toggle="modal"
         >
    Paziente Rifiuta
  </button>
  <button *ngIf="request.status.code === 'CPZ' && (requestDates && isDatePresent('DCS')) && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#patientRefuseModal" data-bs-toggle="modal"
         >
    Paziente Rifiuta
  </button>
  <button *ngIf="request.status.code === 'CST' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#insertDischargeDateModal" data-bs-toggle="modal"
         >
    Inserisci data di dimissione effettiva
  </button>
  <button *ngIf="request.status.code === 'CST' && !authService.isOperatoreUvm && !authService.isOperatoreUvcp && (request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP')"
          [itButton]="'danger'" [size]="'xs'" class="me-2"
          data-bs-target="#restartArruolamentoModal" data-bs-toggle="modal"
         >
    Ricomincia percorso
  </button>
    <button *ngIf="request.status.code === 'END'  && !authService.isOperatoreUvm && !authService.isOperatoreUvcp"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#insertDischargeDateModal" data-bs-toggle="modal">
    Aggiorna data dimissione effettiva
  </button>
  </div>
</div>


<it-modal
  #confirmStructureModal="itModal"
  alignment="left"
  scrollable="true"
  id="confirmStructureModal"
  size="xl">
  <ng-container modalTitle>Conferma Struttura</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'presumedDischargeDate', 'choosedFacility']"></app-discharge-info>
    </div>
  </div>
  <!-- <div class="row mt-2">
    <div class="col">
      <app-confirm-structure (changeConfirmed)="changeStructureConfirmed($event)" (cancelled)="cancelledChangeStructure()"></app-confirm-structure>
    </div>
  </div> -->
  <div class="row mt-2">
    <div class="col">
      <app-confirm-structure-modal (structureConfirmed)="structureConfirmed($event)" (cancelled)="cancelledConfirmStructure()"></app-confirm-structure-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #rightModal="itModal"
  alignment="left"
  scrollable="true"
  id="structureModal"
  size="xl"
>
  <ng-container modalTitle>Strutture</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['presumedDischargeDate']" [dischargeInfo]="requestDates"></app-discharge-info>
    </div>
  </div>
  <div class="mt-4">
    <div class="row">
      <div class="col">
        <it-input
          [(ngModel)]="searchTerm"
          placeholder="Cerca per ASL o Denominazione"
          [type]="'text'"
          (input)="filterStructures()"
          class="mb-2"
        ></it-input>
      </div>
      <div class="col-2 d-grid">
        <button class="mb-5" 
          [disabled]="searchTerm === ''" 
          [itButton]="'danger'" 
          [size]="'xs'" (click)="resetFilter()">Annulla</button>
      </div>
    </div>
    <div class="it-link-wrapper float-end" *ngIf="!allTypeVisible">
      <a (click)="setAllVisible(true)">
        Visualizza tutte
      </a>
    </div>
    <div class="it-link-wrapper float-end" *ngIf="allTypeVisible">
      <a (click)="setAllVisible(false)">
        Visualizza per setting
      </a>
    </div>
    <it-tab-container [cards]="true" (tabSelected)="getTab($event)">
      <it-tab-item
        [id]="'tab_' + index"
        *ngFor="let tab of structureTypesVisible; let index = index"
        [label]="tab.name"
        [active]="index === 0"
      >
        <it-table compact="true" *ngIf="filteredStructures?.length">
          <ng-container thead>
            <tr>
              <th scope="col">ASL</th>
              <th scope="col">Denominazione</th>
              <th scope="col">Indirizzo</th>
              <th scope="col">Telefono</th>
              <th scope="col">Email</th>
            </tr>
          </ng-container>

          <ng-container tbody>
            <tr
              *ngFor="let structure of filteredStructures"
              (click)="selectStructure(structure)"
              [class.table-primary]="structure === selectedStructure"
              style="cursor: pointer"
            >
              <td>{{ structure.aslId }}</td>
              <td>{{ structure.name }}</td>
              <td>{{ structure.address }}</td>
              <td>{{ structure.telephonNumber }}</td>
              <td>{{ structure.email }}</td>
            </tr>
          </ng-container>
        </it-table>
        <div *ngIf="!filteredStructures?.length" class="text-muted p-2">
          Nessuna struttura trovata.
        </div>
      </it-tab-item>
    </it-tab-container>
  </div>

<ng-container footer>
  <div class="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
    
    <div class="flex-grow-1 mt-2">
      <it-input
        [type]="'date'"
        [(ngModel)]="structureRequestDate"
        [description]="'Data richiesta alla struttura'"
        [label]="'Data richiesta'"
        class="mb-0"
      ></it-input>
    </div>

    <div class="d-flex gap-2 flex-wrap align-items-end">
      <button
        itButton="primary"
        size="lg"
        type="button"
        [disabled]="!selectedStructure || !structureRequestDate"
        (click)="onSubmitStructure()"
        data-bs-dismiss="modal"
      >
        Conferma struttura
      </button>

      <button
        itButton="outline-primary"
        size="lg"
        type="button"
        data-bs-dismiss="modal" (click)="resetStructure()"
      >
        Chiudi
      </button>
    </div>

  </div>
</ng-container>


</it-modal>

<it-modal
  #insertDischargeDateModal="itModal"
  alignment="right"
  scrollable="true"
  id="insertDischargeDateModal"
  size="xl"
>
  <ng-container modalTitle>Inserisci Data di dimissione</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'facilityConfirmDate', 'presumedDischargeDate', 'choosedFacility', 'realDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-insert-discharge-date-modal (requestConfirmed)="insertDischargeDate($event)" (cancelled)="cancelledCompleteRequest()"></app-insert-discharge-date-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #facilityRefuseModal="itModal"
  alignment="right"
  scrollable="true"
  id="facilityRefuseModal"
  size="xl"
>
  <ng-container modalTitle>Inserisci la motivazione del rifiuto</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'choosedFacility', 'presumedDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <!-- <div class="row mt-2">
    <div class="col">
      <it-alert color="danger">
        Attenzione! L'operazione non è annullabile.
      </it-alert>
    </div>
  </div> -->
  <div class="row mt-2">
    <div class="col">
      <app-facility-refuse-modal (facilityRefuse)="deleteConfirmedStructureDate($event)" (cancelled)="cancelledFacilityRefuse()"></app-facility-refuse-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #patientRefuseModal="itModal"
  alignment="right"
  scrollable="true"
  id="patientRefuseModal"
  size="xl"
>
  <ng-container modalTitle>Inserisci la motivazione del rifiuto</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'choosedFacility', 'facilityConfirmDate', 'presumedDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <!-- <div class="row mt-2">
    <div class="col">
      <it-alert color="danger">
        Attenzione! L'operazione non è annullabile.
      </it-alert>
    </div>
  </div> -->
  <div class="row mt-2">
    <div class="col">
      <app-patient-refuse-modal (patientRefuse)="deletePatientConfirmation($event)" (cancelled)="cancelledFacilityRefuse()"></app-patient-refuse-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #restartArruolamentoModal="itModal"
  alignment="right"
  scrollable="true"
  id="restartArruolamentoModal"
  size="xl"
>
  <ng-container modalTitle>Ricomincia il percorso</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'choosedFacility', 'facilityConfirmDate', 'presumedDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-restart-arruolamento-modal (confirmed)="restartArruolamento()" (cancelled)="cancelledRestartArruolamento()"></app-restart-arruolamento-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #ucpdomRequestModal="itModal"
  alignment="left"
  scrollable="true"
  id="ucpdomRequestModal"
  size="xl"
>
  <ng-container modalTitle>Arruolamento</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['presumedDischargeDate']" [dischargeInfo]="requestDates"></app-discharge-info>
    </div>
  </div>
    <div class="row mt-3">
    <!-- <div class="col"> -->
      <div class="flex-grow-1 mt-3">
        <it-input
          [type]="'date'"
          [(ngModel)]="ucpdomRequestDate"
          [description]="'Data richiesta per arruolamento'"
          [label]="'Data richiesta'"
          class="mb-0"
        ></it-input>
      </div>

      <div class="d-flex gap-2 flex-wrap align-items-end">
        <button
          itButton="primary"
          size="lg"
          type="button"
          [disabled]="!ucpdomRequestDate"
          (click)="onSubmitUcpdomRequestDate()"
          data-bs-dismiss="modal"
        >
          Conferma data richiesta arruolamento
        </button>

        <button
          itButton="outline-primary"
          size="lg"
          type="button"
          data-bs-dismiss="modal" (click)="resetUcpdomRequest()"
        >
          Chiudi
        </button>
      </div>
    <!-- </div> -->
  </div>
</it-modal>

<it-modal
  #ucpdomConfirmModal="itModal"
  alignment="left"
  scrollable="true"
  id="ucpdomConfirmModal"
  size="xl"
>
  <ng-container modalTitle>Conferma Arruolamento</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [dischargeInfo]="requestDates" [request]="request" [visibleFields]="['facilityRequestDate', 'presumedDischargeDate', 'choosedFacility']"></app-discharge-info>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-confirm-ucpdom-modal (ucpdomConfirmed)="ucpdomConfirmed($event)" (cancelled)="cancelledConfirmUcpdom()"></app-confirm-ucpdom-modal>
    </div>
  </div>
</it-modal>

<it-modal
  #ucpdomRefuseModal="itModal"
  alignment="right"
  scrollable="true"
  id="ucpdomRefuseModal"
  size="xl"
>
  <ng-container modalTitle>Inserisci la motivazione del rifiuto</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-discharge-info [request]="request" [dischargeInfo]="requestDates" [visibleFields]="['facilityRequestDate', 'choosedFacility', 'presumedDischargeDate']"></app-discharge-info>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-ucpdom-refuse-modal (ucpdomRefuse)="deleteConfirmedUcpdomDate($event)" (cancelled)="cancelledUcpdomRefuse()"></app-ucpdom-refuse-modal>
    </div>
  </div>
</it-modal>

